
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface BillDetailsFormProps {
  type: 'gas' | 'electricity' | 'water';
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange: (value: string, name: string) => void;
  required: boolean;
}

export const BillDetailsForm = ({ 
  type, 
  formData, 
  handleInputChange, 
  handleSelectChange,
  required 
}: BillDetailsFormProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {type === 'gas' && (
        <>
          <div className="space-y-2">
            <Label htmlFor={`${type}PlanName`}>Current Energy Plan Name</Label>
            <Input
              id={`${type}PlanName`}
              placeholder="Current Energy Plan Name"
              name={`${type}PlanName`}
              value={formData[`${type}PlanName`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}Usage`}>Usage (kWh)</Label>
            <Input
              id={`${type}Usage`}
              placeholder="Usage over billing period"
              name={`${type}Usage`}
              value={formData[`${type}Usage`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}Rate`}>Price (p/kWh)</Label>
            <Input
              id={`${type}Rate`}
              placeholder="Price over billing period (p/kWh)"
              name={`${type}Rate`}
              value={formData[`${type}Rate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}StandingCharges`}>Standing Charges (p/Day)</Label>
            <Input
              id={`${type}StandingCharges`}
              placeholder="Standing Charges (p/Day)"
              name={`${type}StandingCharges`}
              value={formData[`${type}StandingCharges`]}
              onChange={handleInputChange}
              required={required}
              type="number"
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}StartDate`}>Start Date</Label>
            <Input
              id={`${type}StartDate`}
              type="date"
              placeholder="Start Date"
              name={`${type}StartDate`}
              value={formData[`${type}StartDate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}EndDate`}>End Date</Label>
            <Input
              id={`${type}EndDate`}
              type="date"
              placeholder="End Date"
              name={`${type}EndDate`}
              value={formData[`${type}EndDate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}AnnualConsumption`}>Estimated Annual Usage (kWh)</Label>
            <Input
              id={`${type}AnnualConsumption`}
              placeholder="Estimated Annual Usage (kWh)"
              name={`${type}AnnualConsumption`}
              value={formData[`${type}AnnualConsumption`]}
              onChange={handleInputChange}
              required={required}
              type="number"
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}PaymentSchedule`}>Payment Schedule</Label>
            <Select
              value={formData[`${type}PaymentSchedule`]}
              onValueChange={(value) => handleSelectChange(value, `${type}PaymentSchedule`)}
            >
              <SelectTrigger id={`${type}PaymentSchedule`} className="w-full">
                <SelectValue placeholder="Current Payment Schedule" className="text-muted-foreground" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Monthly direct debit">Monthly direct debit</SelectItem>
                <SelectItem value="Quarterly direct debit">Quarterly direct debit</SelectItem>
                <SelectItem value="Pay on receipt of bill">Pay on receipt of bill</SelectItem>
                <SelectItem value="Prepayment metre">Prepayment metre</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </>
      )}

      {type === 'electricity' && (
        <>
          <div className="space-y-2">
            <Label htmlFor={`${type}PlanName`}>Current Energy Plan Name</Label>
            <Input
              id={`${type}PlanName`}
              placeholder="Current Energy Plan Name"
              name={`${type}PlanName`}
              value={formData[`${type}PlanName`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}Usage`}>Usage (kWh)</Label>
            <Input
              id={`${type}Usage`}
              placeholder="Usage over billing period"
              name={`${type}Usage`}
              value={formData[`${type}Usage`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}Rate`}>Price (p/kWh)</Label>
            <Input
              id={`${type}Rate`}
              placeholder="Price over billing period (p/kWh)"
              name={`${type}Rate`}
              value={formData[`${type}Rate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}StandingCharges`}>Standing Charges (p/Day)</Label>
            <Input
              id={`${type}StandingCharges`}
              placeholder="Standing Charges (p/Day)"
              name={`${type}StandingCharges`}
              value={formData[`${type}StandingCharges`]}
              onChange={handleInputChange}
              required={required}
              type="number"
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}StartDate`}>Start Date</Label>
            <Input
              id={`${type}StartDate`}
              type="date"
              placeholder="Start Date"
              name={`${type}StartDate`}
              value={formData[`${type}StartDate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}EndDate`}>End Date</Label>
            <Input
              id={`${type}EndDate`}
              type="date"
              placeholder="End Date"
              name={`${type}EndDate`}
              value={formData[`${type}EndDate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}AnnualConsumption`}>Estimated Annual Usage (kWh)</Label>
            <Input
              id={`${type}AnnualConsumption`}
              placeholder="Estimated Annual Usage (kWh)"
              name={`${type}AnnualConsumption`}
              value={formData[`${type}AnnualConsumption`]}
              onChange={handleInputChange}
              required={required}
              type="number"
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}PaymentSchedule`}>Payment Schedule</Label>
            <Select
              value={formData[`${type}PaymentSchedule`]}
              onValueChange={(value) => handleSelectChange(value, `${type}PaymentSchedule`)}
            >
              <SelectTrigger id={`${type}PaymentSchedule`} className="w-full">
                <SelectValue placeholder="Current Payment Schedule" className="text-muted-foreground" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Monthly direct debit">Monthly direct debit</SelectItem>
                <SelectItem value="Quarterly direct debit">Quarterly direct debit</SelectItem>
                <SelectItem value="Pay on receipt of bill">Pay on receipt of bill</SelectItem>
                <SelectItem value="Prepayment metre">Prepayment metre</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </>
      )}
      
      {type === 'water' && (
        <>
          <div className="space-y-2">
            <Label htmlFor="waterTotalCharge">Total Charge (£)</Label>
            <Input
              id="waterTotalCharge"
              placeholder="Total Charge incl. Water & Used Water (£)"
              name="waterTotalCharge"
              value={formData.waterTotalCharge}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="waterVolumeCharge">Water Volume Charge (£)</Label>
            <Input
              id="waterVolumeCharge"
              placeholder="Water Volume Charge (£)"
              name="waterVolumeCharge"
              value={formData.waterVolumeCharge}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}StartDate`}>Start Date</Label>
            <Input
              id={`${type}StartDate`}
              type="date"
              placeholder="Start Date"
              name={`${type}StartDate`}
              value={formData[`${type}StartDate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor={`${type}EndDate`}>End Date</Label>
            <Input
              id={`${type}EndDate`}
              type="date"
              placeholder="End Date"
              name={`${type}EndDate`}
              value={formData[`${type}EndDate`]}
              onChange={handleInputChange}
              required={required}
              className="placeholder:text-muted-foreground"
            />
          </div>
        </>
      )}
    </div>
  );
};
